import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Toaster } from 'sonner';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <Toaster 
      position="top-right"
      toastOptions={{
        style: {
          border: '1px solid #000000',
          borderRadius: '0',
          fontFamily: 'IBM Plex Sans, sans-serif',
        },
      }}
    />
  </React.StrictMode>
);
